import { render } from "./NpcTrade.vue?vue&type=template&id=7f20b2a1"
import script from "./NpcTrade.vue?vue&type=script&lang=js"
export * from "./NpcTrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/shop/NpcTrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f20b2a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f20b2a1', __exports__)) {
    api.reload('7f20b2a1', __exports__)
  }
  
  module.hot.accept("./NpcTrade.vue?vue&type=template&id=7f20b2a1", () => {
    api.rerender('7f20b2a1', render)
  })

}


export default __exports__